'use client';

import { useCapacitorInit } from '@/src/hooks/use-capacitor';

// ----------------------------------------------------------------------

/**
 * Client component that initializes Capacitor native plugins.
 * Include this in your root layout.
 */
export function CapacitorInit() {
  useCapacitorInit();
  return null;
}
